__turbopack_context__.v({
  "className": "fontbody_64fc64c2-module__iwu46W__className",
  "variable": "fontbody_64fc64c2-module__iwu46W__variable",
});
